'use strict';
var Fp = require('fp/app');
const helpers = require('../common/helpers');

module.exports = class eventActions extends Fp {
	constructor() {
		super()
		this.config = config
	}
	/**
	 * initialize
	 * @description Chargement et import de librairies/modules et callback lors d'événément
	 */
	initialize() {
		let self = this;

		// Sur mobile on affiche directement la carte : pas d'ancre
		if (document.querySelector('.header__content [data-scroll-to="sectionJpJ"]') !== null && helpers.isTouchDevice()) {
			document.querySelector('.header__content [data-scroll-to="sectionJpJ"]').dataset.lightbox = 'carte';
			delete document.querySelector('.header__content [data-lightbox="carte"]').dataset.scrollTo;
		}
		/// #25834 - Visa : lien FT Passeport FP
		let params = new URLSearchParams(document.location.search);
		let name = params.get('ft');
		if (name !== null) {
			self.config.moduleLightBox.then(() => {
				document.querySelector(this.selectors.classMain).dispatchEvent(
					new CustomEvent('lightboxLaunch', {
						bubbles: true,
						detail: {
							libelle: () => {
								return 'ft'
							},
							rubriqueFt: name.replace(/-\d+$/, "")
						}
					})
				);
			}).catch((error) => {
				console.error(error);
			});
		}

		/// Lors d'un click sur <main>, soit la target :
		/// 1. est une lightbox, cela importe le module lightbox puis déclenche l'événement `lightboxLaunch`
		/// 2.soit il s'agit d'une ancre (scroll to section)
		document.querySelector(this.selectors.classMain).addEventListener('click', e => {
			const {
				target
			} = e,
			url = new URL(window.location.href)

			/// 1 === Lightbox
			if (target.dataset.lightbox != undefined || url.hash === '#blockAvis') {
				/// Ticket #19001 lancement popin avis au retour d'une confirmation de demand de devis
				let libelle = url.hash === '#blockAvis' ? 'avis' : target.dataset.lightbox;
				self.config.moduleLightBox.then(() => {
					target.dispatchEvent(
						new CustomEvent('lightboxLaunch', {
							bubbles: true,
							detail: {
								libelle: () => {
									return libelle
								}
							}
						})
					);
				}).catch((error) => {
					console.error(error);
				});
			}
			// Scroll to section au click
			else if (target.dataset.scrollTo != undefined && target.type === 'button') {
				window.scrollTo({
					behavior: 'smooth',
					top: document.querySelector(`#${target.dataset.scrollTo}`).offsetTop
				})
			}
			// click demande FT
			else if (target.dataset.download != undefined) {
				target.dispatchEvent(
					new CustomEvent('downloadFT', {
						bubbles: true,
						detail: {
							libelle: () => {
								return target.dataset.download
							}
						}
					})
				);
			}
			// Click remove element
			else if (target.dataset.remove != undefined) {
				target.dispatchEvent(
					new CustomEvent('removeElement', {
						bubbles: true,
						detail: {
							elementId: () => {
								return target.dataset.remove
							}
						}
					})
				);
			} else if (target.dataset.js === 'showAllListe') {
				target.previousElementSibling.classList.toggle('has-only-first-items-line-showed');
				if ([...target.previousElementSibling.classList].includes('has-only-first-items-line-showed')) {
					target.previousElementSibling.scrollTop = 0;
					target.querySelector('use').setAttribute('xlink:href', '#picto-fp-plus')
				} else {
					target.querySelector('use').setAttribute('xlink:href', '#icon-search-minus')
				}
			} else if (target.dataset.simulate != undefined) {
				helpers.simulateEvent(target.dataset.simulate, 'click')
			}
		});

		// Si il y a un hash '#blockAvis', on simule un click
		let url = new URL(window.location.href)
		if (url.hash === '#blockAvis') {
			let click_event = new CustomEvent('click');
			document.querySelector(this.selectors.classMain).dispatchEvent(click_event);
		}

		/// Liste des écouteurs des événements personnalisés : lightbox, JPJ, Avis
		/// Les événements personnalisés sont crées dans les méthodes _getLightboxContent et _showLightboxContent (pour les avis et le jpj)
		document.querySelector(this.selectors.classMain).addEventListener('lightboxLaunch', (e) => {
			let instance = require('modules/lib/basicLightbox.min');
			if (url.hash === '#blockAvis') {
				self.lightbox(instance, document.querySelector('[data-show="allAvis"]'), e.detail.libelle());
				history.replaceState('', document.title, window.location.href.split('#')[0]);
			} else if (name !== null) {
				self.lightbox(instance, e.target, e.detail.libelle(), e.detail.rubriqueFt)
			} else {
				self.lightbox(instance, e.target, e.detail.libelle());
			}
		});
		document.querySelector(this.selectors.classMain).addEventListener('jpjLaunch', (e) => {
			try {
				const jourParJour = require(self.pathModules + 'jourParJour');
				let jpj = new jourParJour();
				jpj.initialize(parseInt(e.detail.libelle()));
			} catch (e) {
				console.error(e)
			}
		});
		document.querySelector(this.selectors.classMain).addEventListener('showAvis', (e) => {
			if (self.config.hasAvis && self.config.nbAvis > 10) {
				try {
					const modaleAvis = require(self.pathModules + 'avis');
					let avis = new modaleAvis();
					avis.initialize();
				} catch (e) {
					console.error(e)
				}
			}
		});
		document.querySelector(this.selectors.classMain).addEventListener('removeElement', (e) => {
			document.querySelector(e.detail.elementId()).remove();
			document.body.classList.remove('has-overlay');
			document.body.style.removeProperty('overflow');
			delete document.body.dataset.popin;
		})
		document.querySelector(this.selectors.classMain).addEventListener('downloadFT', (e) => {
			const {
				target
			} = e;
			self.downloadFT(target, null)
		})
	}


	/**
	 * lightbox
	 *
	 * @description Méthode de lancement de la lightbox
	 * @param instance : block html / <template> de la lightbox
	 * @param element : button sur lequel on clique
	 * @param libelle : nom de la lightbox
	 */
	lightbox(instance, element, libelle, rubriqueFt) {
		let optionsLightbox = {
				className: `lightbox--${libelle}`,
				onShow: () => {
					document.body.classList.add(this.lightboxClasses.bodyOpen);
				},
				onClose: () => {
					document.body.classList.remove(this.lightboxClasses.bodyOpen);
					if (libelle === 'avis') {
						window.sessionStorage.setItem(`avis-${config.codeProduct}`, document.getElementById('ListeAvisClient').innerHTML)
					}
				}
			},
			arrayLightboxPromise = ['avis', 'participants', 'places-supplementaires', 'contact'];

		/// Gestion différenciée du contenu : GET || déjà existant
		const params = {
			instance,
			element,
			libelle,
			rubriqueFt,
			optionsLightbox
		};
		arrayLightboxPromise.includes(libelle) ? this._getLightboxContent(params) : this._showLightboxContent(params);
	}

	/**
	 * _getLightboxContent
	 *
	 * @description Méthode de récupération du contenu via un fetch
	 * @param instance : block html / <template> de la lightbox
	 * @param element : button sur lequel on clique
	 * @param lightbox libellé de la lightbox
	 * @param optionsLightbox option de la lightbox
	 */
	_getLightboxContent(obj) {
		let self = this,
			url = '',
			instance = obj.instance,
			element = obj.element,
			libelle = obj.libelle,
			optionsLightbox = obj.optionsLightbox;

		optionsLightbox.onClose = function () {
			document.body.classList.remove(self.lightboxClasses.bodyOpen);
		}

		switch (libelle) {
		case 'participants':
			url = `${this.config.urlParticipants}/${this.config.codeProduct}/${element.dataset.date}`;
			break;
		case 'places-supplementaires':
			url = this.config.urlContact;
			break;
		case 'contact':
			url = this.config.urlContact;
			break;
		case 'avis':
			url = element.dataset.urlpopin;
			break;
		}
		self.getPromiseHtml(url)
			.then((data) => {
				const templateInstance = instance.create(data, optionsLightbox);
				templateInstance.show();
			})
			.then(() => {
				if (libelle === 'demandeFt') {
					self._demandeFT()
				} else if (libelle === 'avis') {
					element.dispatchEvent(
						new CustomEvent('showAvis', {
							bubbles: true,
							detail: {
								libelle: () => {
									return 'avis'
								}
							}
						})
					);
				} else if (libelle === 'contact' || libelle === 'places-supplementaires') {
					self.contactForm('formContact', obj);
					if (libelle === 'places-supplementaires') {
						document.getElementById('formContact').querySelector('.fp__titre').innerHTML = 'Demande de place supplémentaires';
					}
				}
			});
	}
	/**
	 * _showLightboxContent
	 *
	 * @description Méthode d'affichage du contenu de la lightbox
	 * @param instance : block html / <template> de la lightbox
	 * @param element : button sur lequel on clique
	 * @param libelle libellé de la lightbox
	 * @param optionsLightbox option de la lightbox
	 */
	_showLightboxContent(obj) {
		let self = this,
			instance = obj.instance,
			element = obj.element,
			libelle = obj.libelle,
			rubrique = obj.rubriqueFt,
			optionsLightbox = obj.optionsLightbox;
		if (libelle === 'jpj') {
			optionsLightbox.onClose = function () {
				document.body.classList.remove(self.lightboxClasses.bodyOpen);
				document.getElementById(libelle).innerHTML = templateInstance.backup;
				document.querySelector(`[data-index="${window.sessionStorage.getItem('jpjActif')}"]`).scrollIntoView({
					behavior: 'smooth'
				});
				document.body.classList.remove(self.lightboxClasses.bodyOpen);
			}
			optionsLightbox.className = `${this.selectors.classJour} lightbox--${libelle}`;
		} else {
			optionsLightbox.onClose = function () {
				document.body.classList.remove(self.lightboxClasses.bodyOpen);
			}
		}

		const templateInstance = instance.create(document.querySelector(`[data-template='${libelle}']`), optionsLightbox);
		templateInstance.show();

		switch (libelle) {
		case 'calendrier':
			self.config.calendrierLiberte.then(() => {
				const lib = require(`${this.pathModules}liberte`);
				let liberte = new lib();
				liberte.launchDatepicker(element);
			});
			break;
		case 'carousel':
			if (!helpers.isTouchDevice()) {
				let snapModule = require('modules/snap');
				let snap = new snapModule();
				snap.carousel('.fp__carousel');
			}
			break;
		case 'video':
			/// On affiche les infos de la première vidéo
			let infosVideo = JSON.parse(localStorage.getItem(`video-${config.idVideo}`)),
				moduleVideo = require('modules/video'),
				video = new moduleVideo();

			if (infosVideo != null) {
				document.querySelector(`.${optionsLightbox.className} .video__titre`).innerHTML = infosVideo.title;
				document.querySelector(`.${optionsLightbox.className} p`).innerHTML = infosVideo.description;
				document.querySelectorAll(`.${optionsLightbox.className} [data-video-id]`).forEach((el) => {
					self.video(el.dataset.videoId)
				});
			}
			this.config.videoPlayerLib.then(() => {
				const player = video.playerVideo();
				video.thumbnailsVideo(player);
			});
			break;
		case 'ft':
			/// On importe une extension de class
			let settingsFT = {
				classFT: `lightbox--${libelle}`,
				rub: rubrique ?? element.dataset.rubriqueFt
			}
			const ficheTechnique = require(`${this.pathModules}ft`);
			let ft = new ficheTechnique();
			ft.initialize(settingsFT)
			break;
		case 'jpj':
			new Promise((resolve, reject) => {
				templateInstance.backup = templateInstance.element().querySelector(`.${self.lightboxClasses.placeholder}`).innerHTML;
				templateInstance.element().insertAdjacentHTML('afterbegin', '<header>Jour par jour</header>');
				templateInstance.element().insertAdjacentHTML('beforeend', `<nav class="jpj__nav">${templateInstance.element().querySelector(`.${self.lightboxClasses.placeholder} menu`).innerHTML}</nav>`);
				resolve();
			}).then(() => {
				document.querySelector(this.selectors.classMain).dispatchEvent(
					new CustomEvent('jpjLaunch', {
						bubbles: true,
						detail: {
							libelle: () => {
								return parseInt(element.dataset.index)
							},
							lightboxClass: () => {
								return `.lightbox--${libelle}`;
							}
						}
					})
				);
			});
			break;
		case 'ecoresponsable':
			document.querySelectorAll(`.sidebar__link`).forEach((elem, index) => {
				elem.parentElement.classList.toggle(this.selectors.activeClass, new URL(elem.href).hash === `#${element.dataset.section}`)
				elem.addEventListener('click', (e) => {
					let section = new URL(elem.href).hash;
					e.preventDefault();
					document.getElementById(section.substring(1)).scrollIntoView({
						behavior: "smooth"
					})
					history.pushState(null, null, '');
					Array.from(elem.parentElement.parentElement.children).forEach(el => el.classList.remove(this.selectors.activeClass))
					elem.parentElement.classList.add(this.selectors.activeClass);
				})
			});
			document.getElementById(element.dataset.section).scrollIntoView({
				behavior: "smooth"
			})
			break;
		case 'carte':
			break;
		default:
			console.warn(`Sorry, we are out of ${libelle}.`);
		}
	}

	/**
	 * Demande de contact
	 *
	 */
	contactForm(id, obj) {

		/// Gestion de l'indicatif téléphonique
		settingsApp.modules.moduleIndicatifTel.then(() => {
			const tel = require(`modules/indicatifTelephonique`);
			let indicatifTel = new tel({
				hasFixe: false
			});
			indicatifTel.changeIndicatif(true, false);
		});

		/// Gestion validation formulaire
		let settings = {
				hasTelephone: true,
				hasTelephoneMobile: true,
				hasCivilite: true,
				msg: {
					charactersForbidden: /[a-zA-Z]+/g,
					indicatif: 'Indicatif obligatoire.',
					noTelephone: 'Vous devez saisir votre numéro de téléphone.',
					formatTelephone: 'Le format de votre numéro de téléphone est invalide.',
					fields: {
						indicatif: {
							mobile: 'CodeIsoForMobile'
						},
						telephone: {
							mobile: 'TelMobile'
						}
					},
					validationIdMsg: {
						mobile: 'validationMessageTelMobile'
					}
				}
			},
			self = this,
			form = document.getElementById(id),
			contactFormValidation = new Formulaire(settings),
			sujet = '',
			type = obj.libelle;

		contactFormValidation.initialize(id);

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			if (!contactFormValidation._isFormValid(form)) {
				contactFormValidation.validationForm(form);
			} else {
				let formData = new URLSearchParams(new FormData(e.target));

				// Ajout des paramètres avant le POST
				if (type === 'places-supplementaires') {
					formData.append('to', 'infos');
					sujet = `Demande de place supplémentaires - ${self.config.codeProduct} -  ${obj.element.dataset.date}`
					formData.append('sujet', sujet);
				} else {
					sujet = `Demande de contact - ${self.config.codeProduct}`
					formData.append('sujet', sujet);
				}

				// Fetch set contact
				self.getPromiseHtml(e.target.action, {
					method: 'POST',
					body: formData // event.target is the form
				}).then((reponse) => {
					const wrapper = document.createElement('div');
					wrapper.classList.add('notification');

					if (JSON.parse(reponse).Message === null) {
						wrapper.classList.add('is-error');
						wrapper.id = 'errorData';
						wrapper.innerHTML = JSON.parse(reponse).MessageError;
						if (document.getElementById('errorData') === null) {
							document.querySelector(`#${id} [data-form-submit]`).insertAdjacentElement('beforebegin', wrapper);
						}
					} else {
						// Message OK
						wrapper.classList.add('is-valid');
						wrapper.innerHTML = JSON.parse(reponse).Message;
						document.querySelector(`.lightbox--${type} .${self.lightboxClasses.placeholder}`).innerHTML = '';
						document.querySelector(`.lightbox--${type} .${self.lightboxClasses.placeholder}`).append(wrapper);
						document.querySelector(`.lightbox--${type}`).classList.add(`ok`)

						//On ferme la popin au bout de `self.delay`
						setTimeout(function () {
							if (document.querySelector(`.lightbox--${type}`) !== null) {
								document.querySelector(`.lightbox--${type}`).remove()
								document.body.classList.remove(self.lightboxClasses.bodyOpen);
							}
						}, self.delay);
					}
					let obj = {
						id: id,
						email: formData.get('Email'),
						libelle: formData.get('sujet')
					}
					return obj;
				}).
				then((obj) => {
					helpers._dispatchEventSubmitForm(obj, this.selectors.classMain);
				}).catch((error) => {
					console.error(error)
				});
			}
		});
	}
}